export default (number) => {
    const regexPattern = /^-?[0-9]+$/;

    const result = regexPattern.test(number);

    return result;
}


// WEBPACK FOOTER //
// ./src/helpers/isIntegerOrFloat.js